/**
 * @generated SignedSource<<f858fe94c523f5ffe43232d766c25444>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type JobScheduleStatusEnum = "AHEAD" | "DELAYED" | "ON_TIME";
import { FragmentRefs } from "relay-runtime";
export type TimerContentStatusBadgeFragment$data = {
  readonly durations: {
    readonly differenceVsPlannedStopMinutes: number | null | undefined;
  } | null | undefined;
  readonly scheduleStatus: JobScheduleStatusEnum | null | undefined;
  readonly " $fragmentType": "TimerContentStatusBadgeFragment";
};
export type TimerContentStatusBadgeFragment$key = {
  readonly " $data"?: TimerContentStatusBadgeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimerContentStatusBadgeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimerContentStatusBadgeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduleStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Durations",
      "kind": "LinkedField",
      "name": "durations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "differenceVsPlannedStopMinutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};

(node as any).hash = "c59500dc235cbc155615b51613f95708";

export default node;
